import { render, staticRenderFns } from "./GroupBookingSucceed.vue?vue&type=template&id=c2b3b1ee&scoped=true&lang=html&"
import script from "./GroupBookingSucceed.vue?vue&type=script&lang=js&"
export * from "./GroupBookingSucceed.vue?vue&type=script&lang=js&"
import style0 from "./GroupBookingSucceed.vue?vue&type=style&index=0&id=c2b3b1ee&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b3b1ee",
  null
  
)

export default component.exports